var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bulk-review modal fade",
      attrs: {
        id: "bulk-shipment-modal",
        role: "dialog",
        "data-backdrop": "static",
        "data-keyboard": "false"
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "summary-box" }, [
              _c("div", { staticClass: "flex gap-10" }, [
                _c("strong", [
                  _vm._v(
                    "出荷データを" +
                      _vm._s(_vm.shippings.length) +
                      "件読み込みました"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flexbox gap-10" }, [
                  _c("span", { staticClass: "valid" }, [
                    _vm._v("✔ " + _vm._s(_vm.validCount) + " 成功")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "error" }, [
                    _vm._v("✖ " + _vm._s(_vm.errorCount) + " エラー")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flexbox gap-10" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-warning",
                    attrs: { type: "button" },
                    on: { click: _vm.reUploadCSV }
                  },
                  [_vm._v("CSVアップロード")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.submitSelected }
                  },
                  [
                    _vm._v(
                      "\n            確定 (" +
                        _vm._s(_vm.selectedCount) +
                        ")\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.close()
                      }
                    }
                  },
                  [_vm._v("閉じる")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.overQuantityItems.length > 0 ||
            _vm.duplicateRequestNos.length > 0
              ? _c("div", { staticClass: "error-box" }, [
                  _vm.overQuantityItems.length > 0
                    ? _c("div", [
                        _c("i", {
                          staticClass: "fa fa-exclamation-triangle",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          " 以下の商品の合計数量が在庫数を超えています\n          "
                        ),
                        _c(
                          "ul",
                          _vm._l(_vm.overQuantityItems, function(e, i) {
                            return _c("li", { key: i }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(e) +
                                  "\n            "
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duplicateRequestNos.length > 0
                    ? _c("div", [
                        _c("i", {
                          staticClass: "fa fa-exclamation-triangle",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" 依頼番号が重複しています\n          "),
                        _c(
                          "ul",
                          _vm._l(_vm.duplicateRequestNos, function(e, i) {
                            return _c("li", { key: i }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(e) +
                                  "\n            "
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "max-height": "70vh", overflow: "auto" } },
              _vm._l(_vm.shippings, function(shipping) {
                return _c("OrderCard", {
                  key: shipping.index,
                  attrs: { order: shipping },
                  on: {
                    validateAll: _vm.validateAll,
                    deleteShipping: _vm.deleteShipping
                  }
                })
              }),
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.openConfirmModal
        ? _c("modal-confirm", {
            attrs: { message: _vm.confirmMessage },
            on: { confirm: _vm.submitRegister, close: _vm.closeModalConfirm }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.addedMessage,
              customHide: true,
              modalWidth: 550
            },
            on: { close: _vm.closeModalAlert }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b0a605c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0a605c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/BulkShipmentReview.vue
// module id = null
// module chunks = 